














































import Vue from 'vue';
import {getTripType, /*getSolutionContexts,*/ updateOrigin, updateSolution, getTripId} from '@/store/state/helpers';
import {TripWayTypes} from '@/views/amex/app-types';

import FilterInput from '../common-components/trip-inputs/filter-input.vue';
import LocationAutocomplete from '../common-components/trip-inputs/location-autocomplete.vue';
import DateSelector from '../common-components/trip-inputs/date-selector.vue';

import {DateRange, TripPartInfo, createTripPartInfo} from '../common-components/trip-inputs/trip-inputs-helper';
import {POISearchOption} from '@/store/api/search-poi';
import {ProblmSubmissionRoute} from '@/store/state/global.types';

export default Vue.extend({
  name: 'SummaryTripInputs',
  components: {
    FilterInput,
    LocationAutocomplete,
    DateSelector,
  },
  props: {
    timeframe: {
      type: String,
      default: '',
    },
    travelers: {
      type: String,
      default: '',
    },
    destination: {
      type: String,
      default: () => null,
    },
    origin: {
      type: Object,
      default: () => null,
    },
    hideOrigin: {
      type: Boolean,
      default: false,
    },
    hideDates: {
      type: Boolean,
      default: false,
    },
    hideTravelers: {
      type: Boolean,
      default: false,
    },
    startDate: Number,
    endDate: Number,
  },
  data() {
    return {
      primaryDestination: null,
      tripDestinations: [createTripPartInfo()] as TripPartInfo[],
    };
  },
  computed: {
    tripWayType(): string {
      return getTripType();
    },

    dateRangeMode(): boolean {
      return this.tripWayType === TripWayTypes.roundTrip;
    },
  },
  methods: {
    async onOriginSelect(value: POISearchOption) {
      // TODO: what we do here?
      await updateOrigin(value);
      const newTripId = getTripId();
      await updateSolution(newTripId, ProblmSubmissionRoute.SOLUTION, []);
    },

    onDateSelect(dateRange: DateRange) {
      // TODO: use real index
      const index = 0;
      // const destinations = getSolutionContexts();
      // const index = destinations.findIndex((destination) => destination.name.replace('_', ', ') === this.destination);

      // update date range for the destination
      this.tripDestinations[index].dateRange = dateRange;

      // if (this.tripWayType === TripWayTypes.multiCity) {
      //   setMinDatesAndValidateDates(this.tripDestinations);
      // }

      this.$emit('dates-selected', dateRange);
    },
  },
});
